import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';

/**
 * Отвечает за то, включена ли форма покукпателя на чекауте
 */
export const HAS_CUSTOMER_FORM = getIsFeatureHasAnOption('customer_form', 'on');
